/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject, PLATFORM_ID, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';

import { environment } from 'environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  public state = signal({ browser: false });

  constructor(
    @Inject(PLATFORM_ID) private pid: object,
    private router: Router
  ) {
    this.state.update((value) => ({
      ...value,
      browser: isPlatformBrowser(this.pid),
    }));

    if (isPlatformBrowser(this.pid)) {
      /**
       * Unicons icon refreshed on route change.
       */
      this.router.events.forEach((event) => {
        if (event instanceof NavigationEnd) {
          (window as any).dataLayer = (window as any).dataLayer || [];
          (window as any).dataLayer.push({
            event: 'pageview',
            pagePath: event.urlAfterRedirects,
          });
        }

        if (!(event instanceof NavigationEnd)) {
          return;
        }
        window.scrollTo(0, 0);
      });

      this.setCookieConsent();
      this.setGoogleTagManager();
    }
  }

  private setCookieConsent(): void {
    const head = document.getElementsByTagName('head')[0];

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `document.addEventListener('DOMContentLoaded', function () {
      cookieconsent.run({ "notice_banner_type": "interstitial", "consent_type": "express", "palette": "dark", "language": "en", "page_load_consent_levels": ["strictly-necessary"], "notice_banner_reject_button_hide": false, "preferences_center_close_button_hide": false, "page_refresh_confirmation_buttons": false, "website_name": "https://www.xbaht.com", "website_privacy_policy_url": "${document.location.origin}/privacy-policy" });
    });`;

    head.appendChild(script);
  }

  private setGoogleTagManager(): void {
    if (!environment.google.gtm) return;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML =
      `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push` +
      `({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)` +
      `[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=` +
      `'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})` +
      `(window,document,'script','dataLayer','` +
      environment.google.gtm +
      `');`;
    document.head.appendChild(script);

    const iframe = document.createElement('iframe');
    iframe.setAttribute(
      'src',
      'https://www.googletagmanager.com/ns.html?id=' + environment.google.gtm
    );
    iframe.width = '0';
    iframe.height = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';

    const noscript = document.createElement('noscript');
    noscript.appendChild(iframe);
    document.body.appendChild(noscript);
  }
}
